<template>
  <div class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <h2><i class="fas fa-map-marker-alt"></i> {{ $t('address.new_address') }}</h2>

      <!-- Mensagens de erro do backend -->


      <form @submit.prevent="submitEndereco">
        <div class="form-grid">
          <ContainerComponent :validator="v$.endereco.nome" class="form-group full">
            <label>{{ $t('address.name') }}</label>
            <input v-model="endereco.nome" type="text" @blur="v$.endereco.nome.$touch" required />
          </ContainerComponent>
</div>
<div class="form-grid">
          <template v-if="isBrazilian">
            <ContainerComponent :validator="v$.endereco.cep" class="form-group full">
              <label>{{ $t('address.zip_code') }}</label>
              <input v-model="endereco.cep" v-mask="'#####-###'" @blur="buscarCEP(); v$.endereco.cep.$touch()"
                type="text" />

            </ContainerComponent>

            <ContainerComponent :validator="v$.endereco.logradouro" class="form-group full">
              <label>{{ $t('address.street') }}</label>
              <input v-model="endereco.logradouro" type="text" @blur="v$.endereco.logradouro.$touch" />
            </ContainerComponent>

            <ContainerComponent :validator="v$.endereco.numero" class="form-group">
              <label>{{ $t('address.number') }}</label>
              <input v-model="endereco.numero" type="text" @blur="v$.endereco.numero.$touch" />
            </ContainerComponent>

            <ContainerComponent :validator="v$.endereco.bairro" class="form-group">
              <label>{{ $t('address.neighborhood') }}</label>
              <input v-model="endereco.bairro" type="text" @blur="v$.endereco.bairro.$touch" />
            </ContainerComponent>

            <div class="form-group">
              <label>{{ $t('address.city') }}</label>
              <input v-model="endereco.cidade" type="text" disabled />
            </div>

            <div class="form-group">
              <label>{{ $t('address.state') }}</label>
              <input v-model="endereco.estado" type="text" disabled />
            </div>
          </template>

          <template v-else>
            <div class="form-group">
              <label>{{ $t('address.state') }}</label>
              <select v-model="selectedEstadoId" @change="updateCidades">
                <option disabled value="">{{ $t('select_state') }}</option>
                <option v-for="estado in estados" :key="estado.estado_id" :value="estado.estado_id">
                  {{ estado.estado_nome }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label>{{ $t('address.city') }}</label>
              <select v-model="selectedCidadeId" :disabled="!selectedEstadoId">
                <option disabled value="">{{ $t('select_city') }}</option>
                <option v-for="cidade in cidades" :key="cidade.cidade_id" :value="cidade.cidade_id">
                  {{ cidade.nome_cidade }}
                </option>
              </select>
            </div>

            <ContainerComponent :validator="v$.endereco.logradouro" class="form-group full">
              <label>{{ $t('address.street') }}</label>
              <input v-model="endereco.logradouro" type="text" @blur="v$.endereco.logradouro.$touch" />
            </ContainerComponent>

            <ContainerComponent :validator="v$.endereco.numero" class="form-group">
              <label>{{ $t('address.number') }}</label>
              <input v-model="endereco.numero" type="text" @blur="v$.endereco.numero.$touch" />
            </ContainerComponent>

            <ContainerComponent :validator="v$.endereco.bairro" class="form-group">
              <label>{{ $t('address.neighborhood') }}</label>
              <input v-model="endereco.bairro" type="text" @blur="v$.endereco.bairro.$touch" />
            </ContainerComponent>

            <div class="form-group full">
              <label>{{ $t('address.como_chegar') }} ({{ $t('optional') }})</label>
              <textarea v-model="endereco.como_chegar" rows="2"></textarea>
            </div>
          </template>

          <div class="form-group full">
            <label>{{ $t('address.complement') }} ({{ $t('optional') }})</label>
            <input v-model="endereco.complemento" type="text" />
          </div>

          <div class="form-group full">
            <label>{{ $t('address.country') }}</label>
            <input :value="isBrazilian ? 'Brasil' : 'Paraguai'" readonly />
          </div>
        </div>
        <div v-if="backendErrors.length" class="error-message-block">
          <div v-for="(msg, index) in backendErrors" :key="index" class="error-text">
            <i class="fas fa-exclamation-circle"></i> {{ msg }}
          </div>
        </div>
        <div class="modal-actions">
          <button type="button" class="cancel-btn" @click="close">{{ $t('cancel') }}</button>
          <button type="submit" class="save-btn">{{ $t('save') }}</button>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import { required, maxLength } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import { mask } from 'vue-the-mask'
import { estados_py } from '../components/Cidades'
import ContainerComponent from '../components/ContainerComponent.vue'
import { mapGetters } from 'vuex'
import axios from 'axios'
import { resolveError } from '@/components/helpers/responseHelper'



export default {
  name: 'AlterarEnderecoModal',
  directives: { mask },
  components: { ContainerComponent },
  setup() {
    return { v$: useVuelidate() }
  },
  computed: {
    ...mapGetters('auth', ['getUser']),
    isBrazilian() {
      return this.getUser?.estrangeiro == 1;
    }
  },
  data() {
    return {
      estados: estados_py,
      cidades: [],
      selectedEstadoId: '',
      selectedCidadeId: '',
      backendErrors: [],
      endereco: {
        nome: '',
        cep: '',
        logradouro: '',
        numero: '',
        bairro: '',
        cidade: '',
        estado: '',
        pais: '',
        complemento: '',
        como_chegar: '',
        ativo: true,
        principal: false,
      }
    }
  },
  validations() {
    return {
      endereco: {
        nome: { required, maxLength: maxLength(100) },
        cep: { required: this.isBrazilian },
        logradouro: { required, maxLength: maxLength(200) },
        numero: { required, maxLength: maxLength(20) },
        bairro: { required, maxLength: maxLength(100) }
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    updateCidades() {
      const estado = this.estados.find(e => e.estado_id == this.selectedEstadoId);
      this.cidades = estado ? estado.cidades : [];
      this.selectedCidadeId = '';
    },
    async buscarCEP() {
      if (!this.isBrazilian || !this.endereco.cep) return;

      const cep = this.endereco.cep.replace(/\D/g, '');
      if (cep.length !== 8) return;

      try {
        const { data } = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);

        if (!data.erro) {
          this.endereco.logradouro = data.logradouro || '';
          this.endereco.bairro = data.bairro || '';
          this.endereco.cidade = data.localidade || '';
          this.endereco.estado = data.uf || '';

          const ibge = data.ibge;
          if (ibge) {
            const response = await axios.post(`${process.env.VUE_APP_API_URI}/ecom/endereco/cidade-por-codigo`, {
              pais_id: 1, // Brasil
              codigo: ibge
            });

            if (response.data && response.data.id) {
              this.endereco.cidade_id = response.data.id;
            }
          }
        }
      } catch (err) {
        console.error('Erro ao buscar CEP e cidade_id:', err);
      }
    },

    async submitEndereco() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      const estado = this.estados.find(e => e.estado_id == this.selectedEstadoId);
      const cidade = this.cidades.find(c => c.cidade_id == this.selectedCidadeId);

      const payload = {
        ...this.endereco,
        pais: this.isBrazilian ? 'Brasil' : 'Paraguai',
        cidade: this.isBrazilian ? this.endereco.cidade : cidade?.nome_cidade || '',
        cidade_id: this.isBrazilian ? this.endereco.cidade_id || null : cidade?.cidade_id || null,
        estado_id: this.isBrazilian ? null : estado?.estado_id || null
      };

      delete payload.estado;

      this.backendErrors = [];

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.backendErrors.push(this.$t('authTokenMissing') || 'Token de autenticação ausente.');
          return;
        }

        await axios.post(`${process.env.VUE_APP_API_URI}/ecom/cliente/address`, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        this.$emit('salvar', payload);
        this.close();
      } catch (error) {
        console.error('Erro ao salvar endereço:', error.response?.data || error.message);
        if (error.response?.status === 401) {
          this.backendErrors.push(this.$t('unauthorizedMessage') || 'Sessão expirada. Faça login novamente.');
        } else if (error.response?.data?.errors) {
          const errors = error.response.data.errors;
          for (const field in errors) {
            if (Array.isArray(errors[field])) {
              this.backendErrors.push(...errors[field]);
            }
          }
        } else {
          this.backendErrors.push(this.$t('errorMessage') || 'Erro ao salvar endereço');
        }
      }
    }
  }
}
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(44, 62, 80, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 95%;
  max-width: 700px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

h2 {
  margin-bottom: 1.5rem;
  font-size: 1.6rem;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.full {
  grid-column: span 2;
}

input,
textarea {
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

.error-message-block {
  background-color: #fdecea;
  border: 1px solid #e74c3c;
  padding: 1rem;
  margin-bottom: 1rem;
  border-radius: 8px;
}

.error-text {
  color: #e74c3c;
  font-size: 0.95rem;
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

input:focus,
textarea:focus {
  border-color: #3498db;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.3);
  outline: none;
}

.modal-actions {
  margin-top: 2rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.cancel-btn {
  background: #bdc3c7;
  color: #2c3e50;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  cursor: pointer;
}

.save-btn {
  background: #27ae60;
  color: white;
  border: none;
  padding: 0.6rem 1.5rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #95a5a6;
}

.save-btn:hover {
  background: #2ecc71;
}

select {
  padding: 0.6rem 0.8rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
  background-color: white;
  color: #333;
  appearance: none;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

select:focus {
  border-color: #3498db;
  box-shadow: 0 0 5px rgba(52, 152, 219, 0.3);
  outline: none;
}
@media (max-width: 600px) {
  .modal-content {
    padding: 1rem;
    width: 100%;
    max-height: 100vh;
    overflow-y: auto;
    border-radius: 0;
    height: 100vh;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }

  .full {
    grid-column: span 1;
  }

  .modal-actions {
    flex-direction: column;
    gap: 0.5rem;
  }

  .modal-actions button {
    width: 100%;
  }
}

</style>